/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon20Regular = forwardRef('ArrowDCornerRightUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.793 7.082a.75.75 0 1 1-1.085 1.036L13.75 3.972V14.5a3.25 3.25 0 0 1-3.25 3.25H2a.75.75 0 0 1 0-1.5h8.5a1.75 1.75 0 0 0 1.75-1.75V3.972L8.293 8.118a.75.75 0 0 1-1.086-1.036l4.166-4.363a2.25 2.25 0 0 1 3.255 0l4.165 4.363Z" })));
});
